import { createFlowAnalyticsTracker } from "../../utils/flowAnalytics/createFlowAnalyticsTracker.js";
import vafFlowStepRegistry from "./vafFlowStepRegistry.js";

export { FLOW_ANALYTICS_ACTIONS } from "../../utils/flowAnalytics/createFlowAnalyticsTracker.js";

export const createVafFlowAnalytics = ({
  getSearchId,
  getSteps,
  getFlowInstance,
  entryFlow = "vaf",
}) =>
  createFlowAnalyticsTracker({
    getSearchId,
    getSteps,
    getFlowInstance,
    entryFlow,
    stepRegistry: vafFlowStepRegistry,
  });
